/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export var getSelectionAreaPoints = function getSelectionAreaPoints(area) {
  var greatestRowIndex = Math.max(area.point1.row, area.point2.row);
  var greatestColumnIndex = Math.max(area.point1.column, area.point2.column);
  var lowestRowIndex = Math.min(area.point1.row, area.point2.row);
  var lowestColumnIndex = Math.min(area.point1.column, area.point2.column);
  return {
    greatestRowIndex: greatestRowIndex,
    greatestColumnIndex: greatestColumnIndex,
    lowestColumnIndex: lowestColumnIndex,
    lowestRowIndex: lowestRowIndex
  };
};